<template>
  <div>
    <PageHead title="通知列表"></PageHead>
    <div class="oa-layout-content">
      <div class="search-flex">
        <div class="query-top-select">
          <div class="query-cont">
            <div class="query-view mr20">
              <div class="query-view-lable">标题：</div>
              <a-input
                allowClear
                class="w200"
                placeholder="请输入标题"
                v-model="queryForm.titleName"
              />
            </div>
            <!-- <div class="query-view mr20">
              <div class="query-view-lable">送达时间：</div>
              <a-date-picker
                allowClear
                class="w200"
                v-model="queryForm.timeHorizon"
                valueFormat="YYYY-MM-DD"
              >
                <a-icon slot="schedule" type="smile"
              /></a-date-picker>
            </div> -->
            <div class="query-view">
              <div class="query-view-lable">确认状态：</div>
              <a-select
                allowClear
                placeholder="不限"
                class="w200"
                v-model="queryForm.affirmState"
              >
                <a-select-option :value="0">已确认</a-select-option>
                <a-select-option :value="1">未确认</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="search-flex-itemm">
          <a-button type="primary" @click="subMit" :loading="loading">
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
      </div>
      <div class="mb20 search-btns mt20">
        <span class="statistics"> 检索统计： {{ total }} 条 </span>
      </div>

      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>

        <div slot="sendState" class="statusDiv" slot-scope="text">
          <span v-if="text == 0"> 未发送 </span>
          <span v-if="text == 1"> 已发送 </span>
        </div>
        <div slot="state" class="statusDiv" slot-scope="text">
          <div v-if="text == 0" class="dot0 mr5"></div>
          <div v-if="text == 1" class="dot1 mr5"></div>
          <div v-if="text == 2" class="dot2 mr5"></div>
          <div v-if="text == 3" class="dot3 mr5"></div>
          <div v-if="text == 4" class="dot4 mr5"></div>
          <span v-if="text == 0"> 待提交 </span>
          <span v-if="text == 1"> 正在审批 </span>
          <span v-if="text == 2"> 已归档 </span>
          <span v-if="text == 3"> 退回 </span>
          <span v-if="text == 4"> 取消 </span>
        </div>
        <div slot="affirmState" class="statusDiv" slot-scope="text">
          <span v-if="text == 0"> 未确认 </span>
          <span v-if="text == 1"> 已确认 </span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record, 1)">
            查看
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>
<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80
  },

  {
    title: '标题',
    dataIndex: 'titleName',
    key: 'titleName',
    ellipsis: true
  },
  {
    title: '发送部门',
    dataIndex: 'organizationName',
    key: 'organizationName',
    ellipsis: true
  },
  {
    title: '发送人',
    dataIndex: 'iniatorName',
    key: 'iniatorName',
    ellipsis: true
  },
  {
    title: '送达时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true
  },
  {
    title: '确认状态',
    dataIndex: 'affirmState',
    key: 'affirmState',
    scopedSlots: { customRender: 'affirmState' },
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 260
  }
]

import {
  getPartyNotice,
  mfNoticeList,
  mfNoticeUserList,
  delPartyNotice,
  mfNoticeDelete,
  withdrawParty,
  mfNoticeWithdrawParty
} from './api/api'
export default {
  data() {
    return {
      // timeHorizon: [], //时间范围
      queryForm: {},
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },

  created() {
    this.load()
  },
  methods: {
    // 查看名称
    lookConT(list) {
      let title = ''
      list.forEach((item, index) => {
        title = index > 0 ? title + '、' + item : title + item
      })
      this.$warning({
        // width: "600px",
        title: title
      })
    },
    // 拉取列表
    load() {
      this.loading = true
      let params = this.queryForm
      params.page = this.page
      params.size = this.size
      params.userId = this.$store.state.app.userInfo.id
      // if (this.timeHorizon.length > 0) {
      //   //选择了时间范围
      //   params.startTime = this.timeHorizon[0]
      //   params.endTime = this.timeHorizon[1]
      // } else {
      //   delete params.startTime
      //   delete params.endTime
      // }
      mfNoticeUserList(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          //mfNoticeDelete delPartyNotice
          mfNoticeDelete({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    withdrawParty(id) {
      this.$confirm({
        title: '确定撤回吗?',
        okType: 'danger',
        onOk: () => {
          //mfNoticeWithdrawParty withdrawParty
          mfNoticeWithdrawParty({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('撤回成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(record, type) {
      // 根据partyNoticeId 进入详情
      // 根据id 确认收到
      if (type) {
        const { href } = this.$router.resolve({
          path: '/notificationDetail',
          query: {
            id: record.partyNoticeId,
            isEdit: '1',
            affirmState: record.affirmState,
            okaffirmid: record.id
          }
        })
        window.open(href, '_self')
      } else {
        if (id) {
          const { href } = this.$router.resolve({
            path: '/notificationDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_self')
        } else {
          const { href } = this.$router.resolve({
            path: '/notificationDetail'
          })
          window.open(href, '_self')
        }
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    },
    cancel() {
      //取消
      this.queryForm = {}
      this.timeHorizon = []
    },
    subMit() {
      console.log(this.timeHorizon)
      this.page = 1
      this.load()
    }
  }
}
</script>
<style lang="scss" scoped>
.search-flex {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .query-top-select {
    width: calc(100% - 180px);
    .query-cont {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // flex-wrap: wrap;
      .query-view {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        .query-view-lable {
          width: 75px;
          height: 22px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-right: 5px;
        }
      }
    }
  }
  .search-flex-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
.search-btns {
  position: relative;
  .statistics {
    position: absolute;
    right: 50px;
    font-size: 14px;
  }
}

.statusDiv {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/notification/userlist.vue